import initAllPolyfills from './global/polyfills';
import initAccordion from './components/accordion';
import { scrollToEls } from './global/scrollTo';
import headerInit from './sections/header/headerInit';
import { internetExplorerBodges } from './dom/internetExplorerBodges';
import cookieWarning from './dom/cookieWarning';
import { clickToggle } from './global/clickToggle';
import { sizeChartTabs } from './global/sizeChartTabs';
import { sizeChartConversion } from './global/sizeChartConversion';
import quantityAdjustersInit from './components/quantityAdjuster';
import initLoadMore from './sections/products/loadMore';
import initialiseZoom from './components/productZoom';
import preloadLinks from './dom/preloadPages';
import { initSort } from './sections/products/sort';
import {
  toggleForgotPassword,
  initDisplayForgotPasswordPage,
  initChangePassword,
  enabledButtonOnEmailEntered
} from './sections/account/forgot-password';
import { initAccountMobileMenu } from './sections/account/menu';
import initQuantitySelector from './sections/cart/quantitySelector';
import initInputValidator from './global/inputValidator';
import { glidify } from './dom/glidify';
import { glidifyMob } from './dom/glidify';
import addToCartBtnInit from './sections/cart/addToCart';
import { initGeo } from './global/geo';
import { initProductVideo } from './sections/productVideo';
import lazyloadify from './global/lazyload';
import scrollDirectionInit from './dom/scrollDirectionEvent';
import viewSwitcherInit from './dom/viewSwitcher';
import getCountry from './global/getCountry';
import announcementsInit from './components/announcements';
import searchClose from './dom/searchClose';
import initSmoothScrolls from './dom/smoothScrolls';
import initResponsiveVideo from './global/responsiveVideo';
import manualModalOpen from './sections/product/manualModalOpen';
import confetti from './sections/cart/confetti';
import shippingBarsInit from './components/shippingBar';
import bambuserify from './global/bambuser';
import setWindowWidth from './global/responsiveWindow';
import handleNewsletterSubmit from './global/handleNewsletterSubmit';
import calculateInternationalSizing from './dom/calculateInternationalSizing';
import switcherSizing from './dom/switcherSizing';
import updateLoyaltyButtonText from './utils/updateLoyaltyButtonText';
import initFooterBar from './components/footer-bar';


initAllPolyfills(); // leave polyfills at top pls 🍣

window.blubolt = {};

const instantiate = preload => {
  handleNewsletterSubmit();
  internetExplorerBodges();
  lazyloadify();
  headerInit();
  clickToggle();
  sizeChartTabs();
  sizeChartConversion();
  manualModalOpen();
  quantityAdjustersInit();
  cookieWarning();
  initSort();
  toggleForgotPassword();
  enabledButtonOnEmailEntered();
  initDisplayForgotPasswordPage();
  initChangePassword();
  initAccountMobileMenu();
  initQuantitySelector();
  initInputValidator();
  initialiseZoom('[data-main-product-image-wrapper]', 2);
  scrollToEls();
  addToCartBtnInit();
  calculateInternationalSizing();
  switcherSizing();
  initGeo();
  initAccordion();
  initFooterBar();
  initProductVideo();
  viewSwitcherInit();
  bambuserify();
  searchClose();
  initSmoothScrolls();
  initResponsiveVideo();
  updateLoyaltyButtonText();
  setWindowWidth();
  initLoadMore(() => {
    if (typeof window.ReloadSmartWishlist !== 'undefined') {
      window.ReloadSmartWishlist();
    }
    lazyloadify();
  });
  glidifyMob();
  glidify();
  confetti();
  getCountry(country => {
    //anything requires geolocation can go here

    const deliveryPromise = document.querySelector('.confidence-delivery');
    const deliveryPromiseUSA = document.querySelector('.confidence-delivery-usa');

    if (deliveryPromiseUSA && country.handle === 'UK') {
      // Show UK delivery promise, hide US
      deliveryPromiseUSA.classList.add('hide');
    } else if (deliveryPromise && country.handle === 'US') {
      // Show US delivery promise, hide UK
      deliveryPromiseUSA.classList.remove('hide');
      deliveryPromise.classList.add('hide');
    }

    announcementsInit();

    const shippingBanner = document.querySelector('#fsb_placeholder');
    if (shippingBanner && country.handle !== 'GB') {
      shippingBanner.classList.add('hide');
    }
    shippingBarsInit();
  });

  window.addEventListener('blubolt:scrolldir-change', e => {
    document.body.classList.toggle('scrolling-up', e.detail.direction > 0);
  });

  scrollDirectionInit(); // keep this after event listener "blubolt:scrolldir-chang"

  if (preload) {
    preloadLinks();
  }
};

//example for global-e:
//window.addEventListener('blubolt:priceChange', (e) => console.info(e))

// Helper functions
window.blubolt = {
  turboLinksActive: false,
  glides: [],
  initGlides: {
    glidifyMob,
    glidify
  },
  dom: {
    initialiseZoom,
    instantiate,
    viewSwitcherInit,
    calculateInternationalSizing
  },
  device: ''
};

//
// Shopify Event instantiation
// ----------------------------
const shopifyEvents = ['shopify:section:load'];

shopifyEvents.forEach(event => {
  document.addEventListener(event, () => {
    headerInit();
    clickToggle();
    quantityAdjustersInit();
    initAccountMobileMenu();
    lazyloadify();
    announcementsInit();
    shippingBarsInit();
  });
});

//
// Turbo links instantiation
// --------------------------
if (window['theme']['turbolinksEnabled']) {
  // FE DOM (FREEDOM!)
  document.addEventListener('turbolinks:load', () => {
    if (window.blubolt.turboLinksActive) {
      let loadEvent;
      let onLoadEvent;
      if (typeof Event === 'function') {
        loadEvent = new Event('load', {
          bubbles: true,
          cancelable: true
        });
        onLoadEvent = new Event('onLoad', {
          bubbles: true,
          cancelable: true
        });
      } else {
        loadEvent = document.createEvent('Event');
        loadEvent.initEvent('load', true, true);

        onLoadEvent = document.createEvent('Event');
        onLoadEvent.initEvent('onLoad', true, true);
      }
      dispatchEvent(loadEvent);
      dispatchEvent(onLoadEvent);
    }

    window.blubolt.turboLinksActive = true;
    instantiate(true);
  });

  // 404 handle
  window.addEventListener('blubolt:load', () => {
    instantiate(false);
  });

  //
  // Fall back for turbo links failures
  // -----------------------------------
  document.addEventListener('DOMContentLoaded', () => {
    setTimeout(() => {
      if (!window.blubolt.turboLinksActive) {
        console.error('TurboLinks may have failed, loading fall back');
        instantiate(false);
      }
    }, 3500);
  });
}

//
// No Turbolinks? No problem
// ---------------------------
else {
  document.addEventListener('DOMContentLoaded', () => {
    instantiate(false);
  });
}

window.addEventListener('DOMContentLoaded', () => {
  const hidePagination = document.querySelector('.pagination-snippet.product-list');
  if (hidePagination) {
    hidePagination.classList.add('hide');
  }
});

window.addEventListener('DOMContentLoaded', () => {
  const mainHeader = document.querySelector('[data-main-header]');
  const mainHeaderChecker = mainHeader.classList.contains('header-section-inner');
  if (mainHeaderChecker !== true) {
    mainHeader.classList.add('header-section-inner');
  }
});
